export default {
  common: {
    total: "Today"
  }
};
